import Vue from 'vue'

Vue.filter('formattedProductTitle', value => {
  const productTitle = value.split(' ')
  return productTitle.length > 0 ? `<strong class="font-heading">${value.split(' ')[0]}</strong> ${value.substr(value.indexOf(' ') + 1)}` : value
})
